import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest } from 'redux-saga/effects';
import { globalActions as actions } from '.';
import { handleError } from './helpers';

function* handleErrorSaga(action: PayloadAction<any>) {
  try {
    yield handleError(action.payload);
  } catch (err) {
    console.log(err);
  }
}

export function* globalSaga() {
  yield takeLatest(actions.handleError.type, handleErrorSaga);
}
